<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="VUE-APP"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import { wxshare } from '@/utils/utils.js'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  data(){
    return{
      title: '莱客云',
      desc: '我是普莱柯的小姐',
      shareUri: require('../assets/img/reg/01@2x.png'),
    }
  },
  created(){
    wxshare(this.shareUri,this.title,this.desc)
  },
  methods: {

  },
}
</script>
